import { render, staticRenderFns } from "./MoleculeContentEditorBlockParagraph.vue?vue&type=template&id=1a742abe&"
import script from "./MoleculeContentEditorBlockParagraph.vue?vue&type=script&lang=js&"
export * from "./MoleculeContentEditorBlockParagraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports